export default __webpack_public_path__ + "static/page-bg-black-7d73987787eaaf7dd5639a88b935e058.svg";